import { motion } from "framer-motion";
import { Check, X } from "lucide-react";

const FOR_YOU = [
  "You've outgrown stitched-together YouTube tutorials",
  "You want setcraft, not just software tours",
  "You see yourself working with brands, studios — or your own clients",
  "You'd rather graduate with a reel than a certificate",
];

const SKIP = [
  "You want something to half-watch at 2x speed",
  "You're collecting free tips you'll never shoot with",
  "You can't commit hours between sessions",
  "You'd rather watch the industry than join it",
];

export default function ForYouSection() {
  return (
    <section className="bg-lima-ink px-5 md:px-10 py-14 md:py-32 border-t border-white/10" data-testid="foryou-section">
      <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl tracking-tight text-lima-paper leading-[0.98] mb-10 md:mb-20">
        Fifteen chairs. <span className="font-serifit font-normal text-lima-blue">No spectators.</span>
      </h2>
      <div className="grid md:grid-cols-2 gap-px bg-white/10 border border-white/10">
        <motion.div
          initial={{ opacity: 0, y: 30, filter: "blur(10px)" }}
          whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="bg-lima-ink p-8 md:p-12"
          data-testid="foryou-claim"
        >
          <p className="font-mono2 text-[11px] tracking-[0.25em] text-[#6B73FF] mb-8">THIS IS FOR YOU IF —</p>
          <ul className="space-y-5">
            {FOR_YOU.map((t) => (
              <li key={t} className="flex items-start gap-3.5 text-sm md:text-base text-white/80 leading-relaxed">
                <Check size={16} className="text-lima-blue shrink-0 mt-1" /> {t}
              </li>
            ))}
          </ul>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 30, filter: "blur(10px)" }}
          whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
          className="bg-lima-ink p-8 md:p-12"
          data-testid="foryou-skip"
        >
          <p className="font-mono2 text-[11px] tracking-[0.25em] text-white/40 mb-8">SIT THIS ONE OUT IF —</p>
          <ul className="space-y-5">
            {SKIP.map((t) => (
              <li key={t} className="flex items-start gap-3.5 text-sm md:text-base text-white/50 leading-relaxed">
                <X size={16} className="text-lima-red shrink-0 mt-1" /> {t}
              </li>
            ))}
          </ul>
        </motion.div>
      </div>
    </section>
  );
}
